export default __webpack_public_path__ + "static/media/visitor.0d4cd40f.svg";